import { Expose, Exclude } from 'class-transformer';
import { DocumentSnapshot } from 'firebase/firestore';
import { _FirebaseDocument } from './Models';

@Exclude()
export class Config extends _FirebaseDocument {
    @Expose()
    public chatbot_url?: string;

    @Expose()
    public chatbot_name?: string;

    @Expose()
    public chatbot_response_format?: 'markdown' | 'json_markdown';

    /** Base URL of the released agents service (change control specialist, …). */
    @Expose()
    public agents_url?: string;

    /** Base URL of the assessments service (requirements-assessment driving API). */
    @Expose()
    public assessments_url?: string;

    @Expose()
    public student_codes?: string[];

    @Expose()
    public early_access_codes?: string[];

    collection(): string {
        return "system";
    }

    static fromFirebase(o: DocumentSnapshot): Config | null {
        return _FirebaseDocument._fromFirebase(Config, o);
    }
}

